import type { CSSProperties } from 'react'

import type { Campaign, State } from '../../types'

import css from './Option.module.scss'

const stateColor: Record<State, string> = {
	Completed: 'var(--status-completed)',
	Compose: 'var(--light-grey)',
	Running: 'var(--status-running)',
	Stopped: 'var(--status-paused)'
}

type Props = Partial<Pick<Campaign, 'name' | 'state'>>

export const Option = ({ name = '', state = 'Compose' }: Props) => (
	<span
		className={css.campaign}
		style={
			{
				'--active': stateColor[state]
			} as CSSProperties
		}
	>
		{name}
	</span>
)
